import * as React from 'react';
import { Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';

const style = require('./SupplierFieldTechsAnalyticsPage.less');

export default class SupplierFieldTechsAnalyticsPage extends React.Component<any, null> {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div>
				<Route
					path="/supplier/analytics/fieldTechAnalytics/overview"
					exact={true}
					render={(props) => (
						<Redirect
							to={{
								pathname: '/supplier/analytics/fieldTechAnalytics/overview/detail',
							}}
						/>
					)}
				/>
				{this.props.childRoutes.map((r, i) => (
					<RouteWithSubRoutes key={i} {...r} />
				))}
			</div>
		);
	}
}
